<div class="custom-filter-wrapper">
  <div class="custom-filter-header col-md-12 col-sm-12 d-flex p-1">
    <div class="col-md-12 col-sm-12 d-flex p-0">
      <div class="col-md-5 col-sm-5 d-flex">
        <p-radioButton
          name="table_or_pivot"
          class="col-md-5 col-sm-5"
          [value]="true"
          (onClick)="reportType = ''"
          [label]="'table_or_pivot_or_excel' | translate"
          [(ngModel)]="tableOrPivot"
        ></p-radioButton>
        <div
          class="btn-group report-dropdown col-md-8 col-sm-8 p-0"
          dropdown
          [isDisabled]="!tableOrPivot"
        >
          <button
            id="table_or_pivot_list"
            dropdownToggle
            type="button"
            class="btn dropdown-toggle"
            aria-controls="dropdown-custom-html"
          >
            <span class="report-name">{{ tableOrPivotType | translate }}</span>
            <span class="caret"></span>
          </button>
          <ul *dropdownMenu class="dropdown-menu mt-1">
            <li
              role="menuitem"
              class="filter-list"
              (click)="tableOrPivotType = 'list_report'"
            >
              <a class="dropdown-item">
                <span class="report-name">{{ "list_report" | translate }}</span>
              </a>
            </li>
            <li
              role="menuitem"
              class="filter-list"
              (click)="tableOrPivotType = 'matrix_report_compact'"
            >
              <a class="dropdown-item">
                <span class="report-name">{{
                  "matrix_report_compact" | translate
                }}</span>
              </a>
            </li>
            <li
              role="menuitem"
              class="filter-list"
              (click)="tableOrPivotType = 'matrix_report_classic'"
            >
              <a class="dropdown-item">
                <span class="report-name">{{
                  "matrix_report_classic" | translate
                }}</span>
              </a>
            </li>
            <li
              role="menuitem"
              class="filter-list"
              (click)="tableOrPivotType = 'excel_report'"
            >
              <a class="dropdown-item">
                <span class="report-name">{{
                  "excel_report" | translate
                }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-md-5 col-sm-5 d-flex">
        <p-radioButton
          name="monitor_report"
          class="col-md-4 col-sm-4"
          [value]="'monitor_report'"
          [label]="'monitor_report' | translate"
          (onClick)="tableOrPivot = false"
          [(ngModel)]="reportType"
        >
        </p-radioButton>
        <div
          class="btn-group report-dropdown col-md-8 col-sm-8 p-0"
          dropdown
          [isDisabled]="reportType !== 'monitor_report' || loadReport"
        >
          <button
            id="button-custom-html"
            dropdownToggle
            type="button"
            class="btn dropdown-toggle"
            aria-controls="dropdown-custom-html"
          >
            <span class="report-name">{{
              currentReport
                ? currentReport.description
                : ("new_design" | translate)
            }}</span>
            <span class="caret"></span>
          </button>
          <ul *dropdownMenu class="dropdown-menu mt-1">
            <li role="menuitem">
              <button
                class="btn btn-sm btn-default mb-1 mr-1"
                (click)="openDesigner('add')"
              >
                {{ "create_new_design" | translate }}
              </button>
            </li>
            <li
              role="menuitem"
              class="filter-list"
              *ngFor="let item of designList; let i = index"
              [ngClass]="currentReport?.id === item.id ? 'active' : ''"
            >
              <a class="dropdown-item">
                <span class="report-name" (click)="selectReport(item)">{{
                  item.description | translate
                }}</span>
                <span class="text-success" (click)="openDesigner('edit', item)">
                  <i class="fal fa-edit"></i>
                </span>
                <span class="text-danger" (click)="deleteSavedReport(i, item)">
                  <i class="fal fa-trash-alt"></i>
                </span>
              </a>
            </li>
          </ul>
          <button
            class="btn bg-transparent btn-refresh"
            [disabled]="reportType !== 'monitor_report'"
            (click)="getReports()"
          >
            <i class="fal fa-refresh" [class.fa-spin]="loadReport"></i>
          </button>
        </div>
      </div>
      <div class="col-md-2 col-sm-2">
        <button
          class="btn btn-sm btn-greenish"
          [disabled]="reportType === 'monitor_report' && !currentReport"
          (click)="applyReport()"
        >
          {{ "ok" | translate }}
        </button>
        <button class="btn btn-sm btn-default ml-1" (click)="closeReport()">
          {{ "close" | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="col-md-12 col-sm-12 d-flex p-1 report-alert" *ngIf="alertShow">
    <kl-alert
      [message]="alertMessage"
      type="error"
      [show]="alertShow"
      (onClose)="closeAlert()"
    ></kl-alert>
  </div>
  <div class="col-md-12 col-sm-12 header p-0">
    <div class="filter-options col-md-6 col-sm-6">
      <div class="filters-title">
        <h6 class="font-weight-light mb-0">{{ "filters" | translate }}</h6>
      </div>
    </div>
    <div class="filter-options border-left-0 col-md-6 col-sm-6">
      <div class="filters-title">
        <h6 class="font-weight-light mb-0 pl-2">
          {{ "filter_values" | translate }}
        </h6>
      </div>
    </div>
  </div>
  <div class="custom-filter-inner col-md-12 col-sm-12 d-flex">
    <div class="filter-options p-0 col-md-6 col-sm-6">
      <div class="search-filter-form">
        <div class="search-filter-form-content mt-0 border-top-0">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
    <div class="filter-values filter-options row m-0 col-md-6 col-sm-6">
      <div
        class="filter-values-content search-filter-form border-left-0 col-md-12 col-sm-12 p-0"
      >
        <ul class="filter-list col-md-12 col-sm-12 border-top-0">
          <li
            class="col-md-12 col-sm-12"
            *ngFor="let item of selectedReportFilterValues; let i = index"
          >
            <div class="values">
              <span class="key">{{ item.label | translate }} : </span>
              <span class="value" *ngIf="isArray(item.value)">
                <span *ngFor="let val of item.value; let i = index">
                  <i *ngIf="i > 0">, </i>
                  {{ get(val, item.accessor) | translate }}
                </span>
              </span>
              <span class="value" *ngIf="!isArray(item.value)">
                <span *ngIf="isDate(item.value)">
                  {{ convertDate(item.value) }}
                </span>
                <span *ngIf="!isDate(item.value)">
                  <span *ngIf="item.accessor">
                    {{ get(item.value, item.accessor) | translate }}
                  </span>
                  <span *ngIf="!item.accessor">
                    {{ item.value | translate }}
                  </span>
                </span>
              </span>
            </div>
            <div
              class="tooltip-overlay"
              [tooltip]="getTranslated(item.value, item.accessor)"
              container="body"
            ></div>
            <a role="button" class="close" (click)="deleteFromValues(i, item)">
              <i class="fal fa-trash-alt"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
